<template lang="pug">
    .component-statistics-card.statistics-card-6
            .row
                .columns.small-6.medium-2
                    .inner-content.card
                       slot(name="n1")
                .columns.small-6.medium-2
                    .inner-content.card
                        slot(name="n2")
                .columns.small-6.medium-2
                    .inner-content.card
                        slot(name="n3")
                .columns.small-6.medium-2
                    .inner-content.card
                        slot(name="n4")
                .columns.small-6.medium-2
                    .inner-content.card
                        slot(name="n5")
                .columns.small-6.medium-2
                    .inner-content.card
                        slot(name="n6")
</template>
<script type="text/babel">
    export default{
        name: "StatisticsCard6",
        components: {},
        data(){
            return {}
        },
        created() {
        },
        methods: {},
        computed: {}
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// StatisticsCard6.vue?535d14f8